import React, { useEffect, useRef, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { SuesModel } from '../models/SuesModel';
import './_SuesConfigPopUp.css';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { IDNameDescriptionDictionary } from '../models/Site';

type Props = {
    ClosePopup?: Function;
    OnApprove?: Function;
    config?: any;
    messageTitle?: string;
};

const policyTypesList: IDNameDescriptionDictionary = {
    '0': {
        id: 0,
        name: 'סוג ביטוח',
        description: 'סוג ביטוח'
    },
    '1': {
        id: 1,
        name: 'רכב',
        description: 'רכב'
    },
    '2': {
        id: 2,
        name: 'דירה/עסק',
        description: 'דירה/עסק'
    },
    '3': {
        id: 3,
        name: 'עסק',
        description: 'עסק'
    },
    '4': {
        id: 4,
        name: 'חיים',
        description: 'חיים'
    },
    '5': {
        id: 5,
        name: 'בריאות',
        description: 'בריאות'
    },
    '6': {
        id: 6,
        name: 'אחריות מקצועית',
        description: 'אחריות מקצועית'
    },
    '7': {
        id: 7,
        name: 'ביטוח חבויות',
        description: 'ביטוח חבויות'
    },
    '8': {
        id: 8,
        name: 'ביטוח נסיעות לחו"ל',
        description: 'ביטוח נסיעות לחו"ל'
    },
    '9': {
        id: 9,
        name: 'ביטוח צ.מ.ה',
        description: 'ביטוח צ.מ.ה'
    },
    '10': {
        id: 10,
        name: 'ביטוח תאונות אישיות',
        description: 'ביטוח תאונות אישיות'
    },
    '11': {
        id: 11,
        name: 'חקלאי',
        description: 'חקלאי'
    },
    '12': {
        id: 12,
        name: 'ימי/אווירי',
        description: 'ימי/אווירי'
    },
    '13': {
        id: 13,
        name: 'כתב שרות',
        description: 'כתב שרות'
    },
    '14': {
        id: 14,
        name: 'סחורה בהעברה',
        description: 'סחורה בהעברה'
    },
    '15': {
        id: 15,
        name: 'עובדים זרים',
        description: 'עובדים זרים'
    },
    '16': {
        id: 16,
        name: 'קבלנים',
        description: 'קבלנים'
    },
    '17': {
        id: 17,
        name: 'שוק ההון',
        description: 'שוק ההון'
    },
    '18': {
        id: 18,
        name: 'שוק ההון',
        description: 'שוק ההון'
    },
    '19': {
        id: 19,
        name: 'הלוואה חברתית',
        description: 'הלוואה חברתית'
    },
    '20': {
        id: 20,
        name: 'שירותי דרך',
        description: 'שירותי דרך'
    },
    '21': {
        id: 21,
        name: 'חיות',
        description: 'חיות'
    },
    '22': {
        id: 22,
        name: 'עמדת טעינה',
        description: 'עמדת טעינה'
    }
}

const SuesConfigPopup = (props: Props) => {
    const suesModel = new SuesModel();
    const [statuses, setStatuses] = useState<any[]>([]);
    const [activityStatuses, setActivityStatuses] = useState<any[]>([]);
    const [sueTypes, setSueTypes] = useState<any[]>([]);
    const [tab, setTab] = useState<string>('SueStatuses');
    const [newStatusName, setNewStatusName] = useState<string>('');
    const [newTypeName, setNewTypeName] = useState<string>('');
    const [newActivityStatusName, setNewActivityStatusName] = useState<string>('');
    const [policyType, setPolicyType] = useState<string>('0');

    const [policyTypes, setPolicyTypes] = useState<any[]>([
        {
            ids: ['96E4EEDE-586D-4A82-AE29-6CA3E2C65625', 'C35733EF-E78A-49F8-B3A6-F0FC926A1DBE'],
            name: 'ביטוח רכב'
        },
        {
            ids: ['40F871F2-9FC0-4DC5-9C4F-5C738303863A', '8D89DFED-CDD8-4061-B471-20A8641A8471', 'BE4D441F-B312-4524-AFED-CD4F05FF6BD1'],
            name: 'חיים/בריאות/ אחר'
        },
        {
            ids: ['00000000-0000-0000-0000-000000000000'],
            name: `ביטוח עסק וכו'`
        }
    ])

    const loadData = async () => {
        const sueTypesData = await suesModel.sueTypeGetAll();
        setSueTypes(sueTypesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString(),
                isLock: st.isLock
            }
        }));
        const sueStatusesData = await suesModel.sueStatusGetAll();
        const newStatuses = sueStatusesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString(),
                isLock: st.isLock
            }
        })
        console.log('newStatuses', newStatuses)
        setStatuses(newStatuses);
        const sueActivityStatusesData = await suesModel.sueActivityStatusGetAll();
        setActivityStatuses(sueActivityStatusesData.map((st: any) => {
            return {
                label: st.name,
                value: st.id.toString(),
                isLock: st.isLock
            }
        }));

        console.log('loadData', sueTypesData, sueStatusesData, sueActivityStatusesData)
    }

    const prepareData = (statuses: any) => {
        console.log('prepareData');
    }

    const closePopup = (status?: string) => {
        if (props.ClosePopup) {
            props.ClosePopup(status);
        }
    }

    const approve = () => {
        if (props.OnApprove) {
            props.OnApprove();
        }
    }

    const selectTab = (tabName: string) => {
        setTab(tabName);
    }

    const onNewStatusNameChange = (e: any) => {
        const newName = e.target.value;
        setNewStatusName(newName);
    }

    const onAddStatus = async () => {
        if (newStatusName !== '') {
            const response = await suesModel.addSueStatus({
                Name: newStatusName
            });
            loadData();
            setNewStatusName('');
        }
    }

    const onDeleteStatus = async (id: string) => {
        if (id !== '') {
            await suesModel.deleteSueStatus(id);
            loadData();
        }
    }

    const onNewTypeNameChange = (e: any) => {
        const newName = e.target.value;
        setNewTypeName(newName);
    }

    const onAddNewType = async () => {
        // check if newTypeName is not empty and policyType is selected
        if (newTypeName !== '' && policyType !== '0') {
            const response = await suesModel.addSueType({
                Name: newTypeName
            });
            loadData();
            setNewTypeName('');
        }
    }

    const onDeleteSueType = async (id: string) => {
        if (id !== '') {
            await suesModel.deleteSueType(id);
            loadData();
        }
    }

    const onNewActivityStatusNameChange = (e: any) => {
        const newName = e.target.value;
        setNewActivityStatusName(newName);
    }


    const onAddNewActivityStatus = async () => {
        if (newActivityStatusName !== '') {
            const response = await suesModel.addSueActivityStatus({
                Name: newActivityStatusName
            });
            loadData();
            setNewActivityStatusName('');
        }
    }

    const onDeleteSueActivityStatus = async (id: string) => {
        if (id !== '') {
            await suesModel.deleteSueActivityType(id);
            loadData();
        }
    }

    const onPolicyTypeChange = (name: string, value: any) => {
        setPolicyType(value);
    }


    const emptyFunc = () => { }

    useEffect(() => {
        loadData();
    }, [])

    return (<>
        <div className={`popup-wrapper assignment-config-popup small-config`}>
            <section className="popup-window rtl">
                <div className="close-icon pointer" onClick={(e: any) => closePopup()}></div>
                <div className="popup-content">
                    <div className="popup-header">
                        <div className="popup-title">
                            {props.messageTitle}
                        </div>
                    </div>
                    <div className="popup-body">
                        <div className="clients-tabs-client-card-tabs client-details-view">
                            <div className={`client-card-tab pointer ${tab == 'SueTypes' ? 'selected' : ''}`} onClick={() => selectTab('SueTypes')}>
                                <div className="label">
                                    סוגי תביעה
                                </div>
                                <div className="under-line"></div>
                            </div>
                            <div className={`client-card-tab pointer ${tab == 'SueModes' ? 'selected' : ''}`} onClick={() => selectTab('SueModes')}>
                                <div className="label">
                                    מצבי תביעה
                                </div>
                                <div className="under-line"></div>
                            </div>
                            <div className={`client-card-tab pointer ${tab == 'SueStatuses' ? 'selected' : ''}`} onClick={() => selectTab('SueStatuses')}>
                                <div className="label">
                                    סטטוסים
                                </div>
                                <div className="under-line"></div>
                            </div>
                        </div>
                        <div className={`client-tab-content client-details-edit-mode ${tab == 'SueTypes' ? '' : 'hide'}`}>
                            <div style={{ flexGrow: 1, maxWidth: '400px' }}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                שם סוג תביעה:
                                            </div>
                                            <div className="value">
                                                <input type='text' value={newTypeName} onChange={onNewTypeNameChange}
                                                style={{border: 'none', width: '100%'}}
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                סוגי פוליסות:
                                            </div>
                                            <div className="value">
                                                <IDNameDescriptionItemSelect
                                                    OnChange={(name: string, value: any) => onPolicyTypeChange(name, value)}
                                                    Id={"policyType"}
                                                    Value={policyType ? policyType : '0'}
                                                    Options={policyTypesList}
                                                    style={{ border: 'none', width: '100%' }}
                                                />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    {newTypeName !== '' && policyType != '0' &&
                                    <div style={{ paddingTop: '42px' }}>
                                        <button className='button blue flex-centered flex-justify-center' onClick={onAddNewType}>הוסף</button>
                                    </div>
                                     }
                                </div>
                                <div className='content-table'>
                                    {sueTypes && sueTypes.map((sueType: any, index: number) => {
                                        return (
                                            <div className='item-data-row' key={index}>
                                                <div className='cell'>{sueType.label}</div>
                                                <div className='cell item-actions pointer'>
                                                    {
                                                        !sueType.isLock && <FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteSueType(sueType.value)} />
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className={`client-tab-content client-details-edit-mode ${tab == 'SueModes' ? '' : 'hide'}`}>
                            <div style={{ flexGrow: 1, maxWidth: '400px' }}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                שם מצב תביעה:
                                            </div>
                                            <div className="value">
                                                <input type='text' value={newActivityStatusName} onChange={onNewActivityStatusNameChange} />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>


                                    <div style={{ paddingTop: '42px' }}>
                                        <button className='button blue flex-centered flex-justify-center' onClick={onAddNewActivityStatus}>הוסף</button>
                                    </div>
                                </div>
                                <div className='content-table'>
                                    {activityStatuses && activityStatuses.map((aStatus: any, index: number) => {
                                        return (
                                            <div className='item-data-row' key={index}>
                                                <div className='cell'>{aStatus.label}</div>
                                                <div className='cell item-actions pointer' title={aStatus.id}>
                                                    {
                                                        !aStatus.isLock && <FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteSueActivityStatus(aStatus.value)} />
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>

                            </div>
                        </div>
                        <div className={`client-tab-content client-details-edit-mode ${tab == 'SueStatuses' ? '' : 'hide'}`}>
                            <div style={{ flexGrow: 1, maxWidth: '400px' }}>
                                <div className="parameter-row">
                                    <div className={`parameter-item`}>
                                        <div className="field">
                                            <div className="title">
                                                שם סטטוס:
                                            </div>
                                            <div className="value">
                                                <input type='text' value={newStatusName} onChange={onNewStatusNameChange} />
                                            </div>
                                            <div className='error-message'>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ paddingTop: '42px' }}>
                                        <button className='button blue flex-centered flex-justify-center' onClick={onAddStatus}
                                        >הוסף</button>
                                    
                                    </div>
                                </div>
                                <div className='content-table'>
                                    {statuses && statuses.map((aStatus: any, index) => {
                                        return (
                                            <div className='item-data-row' key={index}>
                                                <div className='cell'>{aStatus.label}</div>
                                                <div className='cell item-actions pointer'>
                                                    {
                                                        !aStatus.isLock &&
                                                        <FontAwesomeIcon className='pointer' icon={faTrash} onClick={() => onDeleteStatus(aStatus.value)} />
                                                    }
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>

                            </div>
                        </div>
                    </div>
                    <div className="popup-footer">
                        <button className="button white blue-border pointer" onClick={(e: any) => closePopup()}>
                            סגור
                        </button>
                    </div>
                </div>
            </section>
        </div>
    </>

    );
    // }
}
export default SuesConfigPopup;